export default __webpack_public_path__ + "static/media/drops.d9e7865d.png";